var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm.loading
        ? _c("Loading", {
            attrs: { loadingText: _vm.getLanguageStrings.loading },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.filteredProducts && _vm.products.length > 0
        ? _c("div", { staticClass: "container" }, [
            _vm.products.length > 0
              ? _c("div", { staticClass: "columns is-multiline" }, [
                  _c(
                    "div",
                    {
                      staticClass: "column product_list__filters",
                      class: _vm.setColumnLayout("sidebar"),
                    },
                    [
                      _vm.filterOptions &&
                      _vm.filterOptions.layout === "dropdowns"
                        ? [
                            _c("ProductFiltersDropdowns", {
                              ref: "productFiltersComponent",
                              attrs: {
                                productFiltersObject: _vm.filterOptions,
                                languageStrings: _vm.getLanguageStrings,
                              },
                              on: {
                                "filter-trigger": _vm.filterValuesCallback,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filterOptions &&
                      _vm.filterOptions.layout === "sidebar"
                        ? [
                            _c("ProductFiltersSidebar", {
                              ref: "productFiltersComponent",
                              attrs: {
                                productFiltersObject: _vm.filterOptions,
                                languageStrings: _vm.getLanguageStrings,
                              },
                              on: {
                                "filter-trigger": _vm.filterValuesCallback,
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "column product_list__products",
                      class: _vm.setColumnLayout("product"),
                    },
                    [
                      _c("div", { staticClass: "column product_list__count" }, [
                        _vm.products.length > 0
                          ? _c("div", [
                              _c("div", [
                                _c(
                                  "span",
                                  [
                                    _vm.getLanguageStrings.products
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getLanguageStrings.products
                                            ) + ":"
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.productsFilter.length) +
                                        " st\n              "
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              !_vm.filterTags.includes("all")
                                ? _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button is-text",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.$refs.productFiltersComponent.clearAllFilters()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.getLanguageStrings
                                                .clear_filters
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.productsFilter.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "columns product-list is-multiline",
                            },
                            _vm._l(
                              _vm.productsFilter,
                              function (productItem, index) {
                                return _c("ProductItem", {
                                  key: index,
                                  attrs: {
                                    productData: productItem,
                                    languageStrings: _vm.getLanguageStrings,
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _c("div", { staticClass: "column is-full" }, [
                            _c("div", { staticClass: "product-list__empty" }, [
                              _vm.getLanguageStrings.filter_no_products_found
                                ? _c("p", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getLanguageStrings
                                            .filter_no_products_found
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }